/**
 * Replaces `{key}` placeholders in a template string with values from `vars`.
 * Unknown placeholders (no matching key in vars) are left as-is.
 */
export function format(
    template: string,
    vars: Record<string, string | number>
): string {
    return template.replace(/\{(\w+)\}/g, (match, key: string) => {
        return key in vars ? String(vars[key]) : match;
    });
}
